import React from "react";
import { Navigate } from "react-router-dom";
import { getAuthUser, isLoggedIn } from "./auth";

function ProtectedRoute({ children, allowedRoles = [], redirectTo = "/login" }) {
  const user = getAuthUser();

  if (!isLoggedIn() || !user) {
    return <Navigate to={redirectTo} replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    if (user.role === "super_admin") {
      return <Navigate to="/super-admin" replace />;
    }

    if (user.role === "shop_admin" || user.role === "manager") {
      return <Navigate to="/dashboard" replace />;
    }

    if (user.role === "cashier") {
      return <Navigate to="/" replace />;
    }

    return <Navigate to={redirectTo} replace />;
  }

  return children;
}

export default ProtectedRoute;